module.exports = __webpack_public_path__ + "img/Kalender_benet.03f1eee1.png";